import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FireServices } from "../../../../../shared/services/api/fire/FireServices";
import { showToastHelper } from "../../utils/showToastHelper";
import { useToast } from "../../../../../shared/hooks";

interface ContractParams {
    quotationId?: string;
    isLoadingExternal?: boolean;
}

export function useFireContract({
    formRef,
    toastHandler,
}: {
    formRef: any;
    toastHandler: ReturnType<typeof useToast>;
}) {
    const [isContracting, setIsContracting] = useState(false);
    const navigate = useNavigate();

    const handleContractQuotation = useCallback(
        async ({ quotationId, isLoadingExternal }: ContractParams): Promise<void> => {
            if (!quotationId || quotationId === "novo") {
                showToastHelper(toastHandler, "Salve o orçamento antes de contratar.", "info");
                return;
            }

            if (isLoadingExternal) {
                showToastHelper(toastHandler, "Aguarde o carregamento dos dados…", "info");
                return;
            }

            // ==== 1. Validar o formulário igual ao salvar ====
            if (!formRef.current?.getData) {
                showToastHelper(toastHandler, "Formulário inválido.", "error");
                return;
            }

            const formData = formRef.current.getData();
            if (!formData) {
                showToastHelper(toastHandler, "Preencha os dados obrigatórios.", "error");
                return;
            }

            // opcional: sua validação específica (evita contratar com campos obrigatórios vazios)
            const invalidFields = Object.keys(formData).filter(
                (k) => formData[k] === undefined || formData[k] === "" || formData[k] === null
            );

            if (invalidFields.length > 0) {
                showToastHelper(toastHandler, "Existem campos pendentes no formulário.", "error");
                console.log("❌ Campos pendentes no formulário:", invalidFields);
                return;
            }

            // ==== 2. Execução da contratação ====
            try {
                setIsContracting(true);

                await FireServices.FireContractQuotation(quotationId);

                showToastHelper(toastHandler, "Cotação contratada com sucesso!", "success");

                // Redireciona igual ao save
                navigate("/incendio");

            } catch (error) {
                console.error("❌ Erro ao contratar:", error);
                showToastHelper(toastHandler, "Erro ao contratar cotação.", "error");
            } finally {
                setIsContracting(false);
            }
        },
        [formRef, toastHandler, navigate]
    );

    return {
        handleContractQuotation,
        isContracting,
    };
}
